import { MapBuilder, px, type Decor, type MapDef } from '../mapdef';

/** The town's railway station: ticket counter, departure board, gates and one platform. */
const b = new MapBuilder(20, 13, ' ');
b.room(0, 0, 20, 10, 'm');
b.fill(1, 8, 18, 1, 'm');
b.fill(1, 9, 18, 1, 'e');
b.fill(0, 10, 20, 3, 'T');
b.fill(0, 3, 1, 2, 'D');

const at = (tx: number, ty: number) => ({ x: px(tx), y: px(ty) });

const decor: Decor[] = [
  { kind: 'departures', x: px(8), y: 1, w: px(5), wall: true },
  { kind: 'window', x: px(15), y: 0, w: px(3), wall: true },
  { kind: 'stationBench', ...at(10, 6), w: px(3), solid: { x: px(8) + 10, y: px(6) - 6, w: px(3) - 4, h: 6 } },
  { kind: 'stationBench', ...at(15, 6), w: px(3), solid: { x: px(13) + 10, y: px(6) - 6, w: px(3) - 4, h: 6 } },
  { kind: 'ticketGates', ...at(10, 8), w: px(14) },
  { kind: 'pottedPlant', x: px(18) + 8, y: px(2) + 12, solid: { x: px(18) + 2, y: px(2) + 6, w: 12, h: 6 } },
];

export const station: MapDef = {
  id: 'station',
  w: b.w,
  h: b.h,
  rows: b.rows(),
  indoor: true,
  theme: { wallFace: '#e6ebee', wallLight: '#f6f9fa', wainscot: '#3a6f9a', wallTop: '#26303a' },
  doors: [{ tiles: [[0, 3], [0, 4]], to: 'town', arrive: { x: px(89), y: px(22) + 8, facing: 'left' } }],
  decor,
  areas: [{ key: 'station', rect: { x: 0, y: 0, w: px(20), h: px(13) } }],
  lights: [
    { x: px(5), y: px(4), r: 90, color: '240,248,255' },
    { x: px(14), y: px(4), r: 90, color: '240,248,255' },
    { x: px(10), y: px(9), r: 100, color: '255,240,210' },
  ],
};
